import styled from 'styled-components'

export const ErrorBlock = styled.span`
    font-size: 12px;
    color: tomato;
    padding: 10px 0px;
    color: ${props => props.theme.color.error} !important;
    text-align: left;
    display: block;
`